import { ComposerKeyType } from '../../keys';

const composer: ComposerKeyType = {
  singular: 'Composer',
  composeButton: 'Compose',
  composeModalTitle: 'Compose scene',
  loading: 'Loading composer…',
  studioRender: 'Render',
  aiImageryTool: 'AI Imagery Tool',
  comingSoon: 'Coming soon',
  renderRequested: 'Render request added to the queue',
  renderRequestFailed: 'Failed to request render',
  requestRender: 'Request render',
  generatingRender: 'Generating render…',
  generatingRenderMessage: 'Rendering your scene — this takes about 1 minute.',
  createdRenders: 'Renders',
  backToScene: 'Back to scene',
  generationModeCompositeRender: 'composite render',
  generationModeLifestyle: 'lifestyle',
  generatingLifestyle: 'Generating lifestyle…',
  generatingLifestyleMessage:
    'Generating your lifestyle image — this takes about 1 minute.',
  lifestylePromptPlaceholder:
    'Describe the scene to generate from this render...',
  addReferences: 'Add references',
  renderCancelled: 'Render cancelled',
  backgroundDefault: 'Default',
  backgroundBlack: 'Black',
  backgroundWhite: 'White',
  backgroundGray: 'Gray',
  backgroundCustom: 'Custom color',
  backgroundColorPicker: 'Color picker',
  productsLibrary: 'Products library',
  productsLibraryHint: '— drag products into the scene to place them',
  releaseToPlace: 'Release to place in the scene',
  noProductsFound: 'No products found',
  composeDisabledMissingModel: 'One or more selected products have no 3D model',
  productLoadFailed: 'Failed to load "{{productName}}" into the scene'
};

export default composer;
